var React = require('react');

function ArrowLeftLineInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ArrowsWithLineDefaultLeft24"},React.createElement("path",{"id":"Icon","fillRule":"evenodd","clipRule":"evenodd","d":"M10.6581 5L12 6.40176L7.63335 11H20V13H7.63335L12 17.5982L10.6581 19L4 12L10.6581 5Z","fill":"#525660"})));
}

ArrowLeftLineInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":""};

module.exports = ArrowLeftLineInline;

ArrowLeftLineInline.default = ArrowLeftLineInline;
